import { store } from '../store';
import { advisorsResetAtom } from './advisors';
import { customersResetAtom } from './customers';

/**
 * 全ページのAdvisorsキャッシュをクリアする
 */
export const refreshAllAdvisorsCache = (): void => {
  store.set(advisorsResetAtom, c => c + 1);
};

/**
 * 全ページのCustomersキャッシュをクリアする
 */
export const refreshAllCustomersCache = (): void => {
  store.set(customersResetAtom, c => c + 1);
};
